/**
 * Attempt to get error message for given error.
 *
 * This attempts to get a useful error message from an error.
 */
export const distillErrorMessage = (error: Error): string => {
    /**
     * We need to be defensive in case TypeScript failed us (or was not
     * applied to the calling code).
     */
    if (error == null) {
        return "Invalid error object";
    }

    const errorString = error.toString();
    /**
     * When we can, we use the toString() variant so that our logging will
     * include the additional error information.
     *
     * For example, new KAError("BOO!", Errors.Internal) will have:
     *    message = "BOO!"
     *    toString = "KAInternalError: BOO!"
     */
    if (errorString !== "[object Object]") {
        return errorString;
    }

    // When toString isn't helpful, we fallback on other means.
    return error.message || error.name || "Unknown";
};
